import { LayoutList, Wallet } from 'lucide-react';
import { formatCurrency } from '../../../shared/utils';

type PolicyStatusCardsProps = {
  /** Total de apólices que batem com os filtros atuais. */
  total: number;
  isLoading?: boolean;
  /** Soma total do prêmio dos registros filtrados. `null`/`undefined` esconde o card. */
  premiumSum?: number | null;
  isPremiumLoading?: boolean;
};

const CARD_BASE_CLASS =
  'flex min-h-[102px] flex-col rounded-2xl border border-alba-gray-200 bg-white px-3 py-3 lg:min-h-[132px] lg:px-4';
const ICON_WRAP_CLASS =
  'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-alba-green-50 lg:h-9 lg:w-9';
const LABEL_CLASS =
  'mt-auto pt-1 font-montserrat text-xs leading-tight text-alba-gray-600 lg:text-sm';

export function PolicyStatusCards({
  total,
  isLoading,
  premiumSum,
  isPremiumLoading,
}: PolicyStatusCardsProps) {
  return (
    <div className='grid w-full grid-cols-1 gap-3 sm:max-w-xl sm:grid-cols-2 lg:gap-4'>
      <div className={CARD_BASE_CLASS}>
        <div className='flex items-start justify-between gap-3'>
          <div className={ICON_WRAP_CLASS}>
            <LayoutList
              className='h-5 w-5 text-alba-green-600'
              strokeWidth={1.6}
            />
          </div>
          <div className='flex min-h-9 items-center justify-end'>
            <span className='font-montserrat text-3xl font-bold leading-none text-alba-black-500 tabular-nums lg:text-2xl'>
              {isLoading ? '—' : total}
            </span>
          </div>
        </div>
        <span className={LABEL_CLASS}>Total de Apólices</span>
      </div>

      <div className={CARD_BASE_CLASS}>
        <div className='flex items-start justify-between gap-3'>
          <div className={ICON_WRAP_CLASS}>
            <Wallet className='h-5 w-5 text-alba-green-600' strokeWidth={1.6} />
          </div>
          <div className='flex min-h-9 min-w-0 flex-1 items-center justify-end'>
            <span
              title={premiumSum != null ? formatCurrency(premiumSum) : undefined}
              className='w-full truncate text-right font-montserrat text-xl font-bold leading-none text-alba-black-500 tabular-nums lg:text-2xl'
            >
              {isPremiumLoading || premiumSum == null
                ? '—'
                : formatCurrency(premiumSum)}
            </span>
          </div>
        </div>
        <span className={LABEL_CLASS}>Valor Total do Prêmio</span>
      </div>
    </div>
  );
}
